import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Store';
import { getLoginLink } from './utils/getLinks';
import { Redirect } from 'react-router-dom';

/********************************************************************************************************
 * Component: UserLockout
 * Purpose:   Handled redirection policy for various actions on the
 *            users profile.   Each action should force the user
 *            to a specific page to complete the action required
 *
 * Props: -   children -  reference to the page the user wanted to navigate to
 *            loading  -  reference to the loading store
 *            user     -  reference to the user store
 *            config   -  reference to the config store
 *            currentSection -  Identifies the current section of the page we are on (optional)
 *            disableRedirect -  Tells the component to NOT redirect to the action page - for
 *                              instance if we are already on that action to prevent redirect loop.  (optional)
 *
 * APIs used:  none
 */
const UserLockout = ({ children, loading, user, config }) => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, [loading, hasMounted, user]);

    if (!hasMounted || loading.actions['getPlayerData'] || loading.actions['getConfig'] || loading.actions['login']) {
        return (
            <div className='loading-wrapper'>
                <div className='loading-overlay'>
                    <div className='loading-icon ellipses'></div>
                </div>
            </div>
        );
    } else {
        if (user.loggedIn) {
            return children;
        } else {
            return <Redirect to={getLoginLink(config)} />;
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLockout);
